module.exports = __webpack_public_path__ + "static/media/c132bhk.ca2bea3a.jpg";